<template>
<span>
  <el-input ref="editor" v-if="visibleEditor" v-model="value" size="mini" :edit="true" controls-position="right" @blur="endEdit()" @keyup.enter.native="endEdit()" @keyup.esc.native="cancelEdit()" :style="`width:${width};`"></el-input>
  <slot v-else name="data"></slot>
</span>
</template>

<script>
export default {
  name: 'WTextEditor',
  props: {
    editing: {
      type: Object,
    },
    target: {
      type: Object,
    },
    property: {
      type: String,
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  data() {
    return {
      value: null,
    };
  },
  computed: {
    visibleEditor() {
      return this.editing.isEditing && this.editing.target === this.target && this.editing.property === this.property;
    },
  },
  watch: {
    visibleEditor(to) {
      if (to === true) {
        this.value = this.editing.value;
        this.$nextTick(() => {
          this.$refs.editor.focus();
          this.$refs.editor.select();
        });
      }
    },
  },
  methods: {
    endEdit() {
      this.$emit('endEdit', this.value, this.editing.value);
    },
    cancelEdit() {
      this.$emit('endEdit', this.editing.value, this.editing.value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/LogicalGroupSettings/components/TextEditor.vue